import { render, staticRenderFns } from "./StoreChoose.vue?vue&type=template&id=0bf36698&scoped=true&"
import script from "./StoreChoose.vue?vue&type=script&lang=js&"
export * from "./StoreChoose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf36698",
  null
  
)

export default component.exports